import React from 'react';

const PageNotFound = () => {
  return (
    <div>
      <h1>Sorry, this page cannot be found</h1>
    </div>
  );
};

export default PageNotFound;
